import { render, staticRenderFns } from "./AddTupleToDependentList.vue?vue&type=template&id=6e55e784"
import script from "./AddTupleToDependentList.vue?vue&type=script&lang=js"
export * from "./AddTupleToDependentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports